import { useParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';

import { PrototypesIcon } from '@app-velocity/icons';
import { useScenarioDetailsContext } from '@app-velocity/modules/scenarios';

import { MessageBus } from '@app-velocity/message-bus';

import { useCurrentTeamPermissions } from '@app-velocity/libs/team-permissions';

import { ActionButton } from '../ActionButton';

const messageBus = new MessageBus('prototypes');

export const ActionRunExtended = () => {
  const { t } = useI18n();
  const currentTeam = useCurrentTeamPermissions();
  const { workspaceId, teamId } = useParams<{
    teamId: string;
    workspaceId: string;
  }>();
  const { scenario } = useScenarioDetailsContext();

  const handleRunExtendedSims = () => {
    if (!workspaceId || !scenario || !teamId || !currentTeam) return;

    if (!currentTeam.canRunSimulations(10)) {
      return;
    }

    messageBus.publish('modal:run-again:open', {
      workspaceId,
      teamId,
      scenarioId: scenario.id!,
      shareToken: scenario.shareToken!,
      amount: 10,
      type: 'EXTENDED',
    });
  };

  return (
    <ActionButton onClick={handleRunExtendedSims}>
      {t('prototypes:run_extended_sims')} <PrototypesIcon />
    </ActionButton>
  );
};
